const enum PROMOTION_TYPES {
  BASIC = "basic",
  ADVANCED = "advanced",
}

const enum PROMOTION_ACTIONS {
  VALUE_DISCOUNT = "gets_value_discount",
  PERCENTAGE_DISCOUNT = "gets_percent_discount",
  PERCENTAGE_DISCOUNT_ON_ORDER = "gets_percent_discount_on_order",
  VALUE_DISCOUNT_ON_ORDER = "gets_value_discount_on_order",
  PAY_FIXED_PRICE = "pay_fixed_price",
  EARN_LOYALTY = "earn_loyalty",
  PERCENTAGE_DISCOUNT_ON_ITEM = "gets_percent_discount_on_item",
  VALUE_DISCOUNT_ON_ITEM = "gets_value_discount_on_item",
  GETS_FREE_ITEM = "gets_free_item",
  GETS_FREE_DELIVERY = "gets_free_delivery",
  GETS_PERCENTAGE_DISCOUNT_ON_DELIVERY = "gets_percent_delivery_discount",
  GETS_VALUE_DISCOUNT_ON_DELIVERY = "gets_value_delivery_discount",
}

const enum PROMOTION_CONDITION_TYPES {
  BUYS_SPECIFIC_ITEMS = "buys_specific_items",
  BUYS_FOR_SPECIFIC_AMOUNT = "buys_for_specific_amount",
}

const enum DISCOUNT_TYPE { //for transformation in payload
  VALUE = "value",
  PERCENTAGE = "percentage",
}

type promoCodeType = {
  id: number;
  code: string;
  code_redemption_limit: number;
  user_redemption_limit: number;
  name: string;
  description: string;
  condition_fullfilled: boolean;
}

type promotionsContextType = {
  appliedPromotionsData: {
    appliedPromotions: any[];
    promotionAppliedCart: any[];
    orderPromotion: any[];
    availablePromoCodes: promoCodeType[];
  };
  newlyAppliedPromotions: any[];
  cartVerificationPayload: any;
  promotionCartBreakdowns: any;
  freeItemCart:any[];
  availablePromoCodes: promoCodeType[];
  promoCodeWidgetData: {
    appliedPromoCode: string;
    promoVerificationStatus: string;
  }
  appliedPromoCode: string;
  promoCodesWithTriggeringRule: promoCodeType[];
  userAcknowledgedPromotionsHandler: (newpromotions: any[]) => void;
  toggleUserClosePromotionPopup: (updatedState: boolean) => void;
  onPromoCodeApply: (promoCode: string) => void;
  resetPromocode: () => void;
};

type verificationPayloadParameterType = {
  userCartItems:any[],
  menu:any,
  orderType:any,
  discount:any|null,
  redeemedPoints:any|null,
  selectedArea:any|null,
  deliveryChargeId:any|null,
  riderTip:any|null,
  orderPromotions:any[],
  company:any,
  outlet:any,
  user:any
  customer_loyalty:any|null,
}

const enum PROMO_CODE_VERIFICATION_STATUS {
  LOADING = "LOADING",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  INVALID = "INVALID",
}

export {
  PROMOTION_TYPES,
  PROMOTION_ACTIONS,
  promotionsContextType,
  PROMOTION_CONDITION_TYPES,
  DISCOUNT_TYPE,
  verificationPayloadParameterType,
  PROMO_CODE_VERIFICATION_STATUS,
  promoCodeType
};
